export const SPECIAL_PRICE_CREATE_TITLE = 'Crear precio especial'

export const SPECIAL_PRICE_CREATE_COPY_TITLE = 'Crear copia de precio especial'

export const SPECIAL_PRICE_CREATE_FORM_DESCRIPTION =
  'Ingrese los siguientes datos para crear un precio especial:'

export const SPECIAL_PRICE_CREATE_SCOPE_OPTIONS = [
  { value: 'client', label: 'Cliente' },
  { value: 'attribute', label: 'Atributo' }
]

export const SPECIAL_PRICE_CREATE_ATTRIBUTE_FILTERS_INITIAL_STATE = {
  price_list_id: '',
  qualifier_2: '',
  qualifier_3: '',
  qualifier_4: '',
  qualifier_5: '',
  qualifier_6: ''
}

export const SPECIAL_PRICE_CREATE_CLIENT_MIN_SEARCH_LENGTH = 3

export const SPECIAL_PRICE_CREATE_PRODUCT_PAGE_SIZE = 25

export const SPECIAL_PRICE_CREATE_PRODUCT_TABLE_COLUMNS = [
  { key: 'product_db_ref', label: 'CÓDIGO DE PRODUCTO' },
  { key: 'product_name', label: 'NOMBRE DE PRODUCTO' },
  { key: 'sales_unit', label: 'UNIDAD DE VENTA' },
  { key: 'current_price', label: 'PRECIO ACTUAL' },
  { key: 'action', label: 'ACCIÓN' }
]

export const SPECIAL_PRICE_CREATE_STEP_CONTENT = {
  scope: {
    title: 'Paso 1: Selección de cliente o atributo',
    description: 'Solo se podrá seleccionar un cliente o atributo a la vez.'
  },
  client: {
    title: '1.1: Escoja a qué cliente se debe aplicar este precio especial',
    description: 'Solo se podrá seleccionar un cliente a la vez.'
  },
  attribute: {
    title: '1.1: Escoja los atributos del cliente para este precio especial',
    description: 'Mínimo debe seleccionar un atributo.'
  },
  product: {
    title: 'Paso 2: Selección de producto',
    description: 'Los productos se filtran según el cliente o los atributos seleccionados.'
  },
  price: {
    title: 'Paso 3: Configuración de precio',
    description: 'Configure uno o varios rangos de cantidades para el mismo producto.'
  },
  dates: {
    title: 'Paso 4: Vigencia',
    description: 'Seleccione las fechas de inicio y fin del precio especial.'
  }
}

export const SPECIAL_PRICE_CREATE_FIELD_LABELS = {
  scopeType: 'Escoger una opción',
  clientSearch: 'Buscar cliente por nombre o código',
  productSearch: 'Buscar productos por nombre o código',
  startDate: 'Fecha inicio',
  endDate: 'Fecha final',
  minSale: 'Minimo de venta',
  maxSale: 'Maximo de venta',
  offerPrice: 'Precio de oferta'
}

export const SPECIAL_PRICE_CREATE_PLACEHOLDERS = {
  attributeSearch: 'Buscar o escoger una opcion',
  price: '0.00',
  unlimited: 'ilimitado'
}

export const SPECIAL_PRICE_CREATE_ACTION_LABELS = {
  cancel: 'Cancelar',
  save: 'Guardar',
  saving: 'Guardando...'
}

export const SPECIAL_PRICE_CREATE_MESSAGES = {
  initialLoadError: 'No se pudo cargar la información inicial del formulario.',
  productWarningEmpty: 'No hay datos disponibles para ese atributo o cliente.',
  clientPriceListMissing:
    'Este cliente no tiene una lista de precios asignada. Por favor asígnele una lista de precio o escoja otro cliente.',
  attributeUnavailable:
    'No hay atributos a escoger. Por favor cree atributos o escoja un cliente.',
  scopeTypeRequired: 'Debe seleccionar un tipo de aplicación.',
  clientRequired: 'Debe seleccionar un cliente.',
  attributeRequired: 'Debe seleccionar al menos un atributo.',
  productRequired: 'Debe seleccionar un producto.',
  productMissingSalesUnit:
    'Error: El producto agregado no tiene una unidad de venta asignada. Verificar el listado antes de continuar.',
  saveError: 'No se pudo guardar el precio especial.',
  saveSuccess: 'Precio especial creado correctamente.',
  copySuccess: 'Precio especial copiado correctamente.',
  reconfigureProduct: 'Configure el paso 2 para continuar.',
  clientNoResults: 'No hay resultados',
  clientMinSearch: 'Escriba al menos 3 caracteres',
  productLoading: 'Cargando productos...',
  productNoResults: 'No hay resultados'
}

export const SPECIAL_PRICE_CREATE_ALERT_MATCHERS = {
  productNotInPriceList:
    'Product db ref no está disponible en la lista de precios seleccionada.',
  overlap:
    'Esta fecha está superpuesta con otro precio especial con el mismo cliente/atributo y producto.',
  missingScopePriceList: 'No se encontró la lista de precios seleccionada.'
}

export const SPECIAL_PRICE_CREATE_ARIA_LABELS = {
  removeProduct: 'Eliminar producto',
  removeScale: 'Eliminar escala',
  startDate: 'Seleccionar fecha inicial',
  endDate: 'Seleccionar fecha final'
}

export const SPECIAL_PRICE_CREATE_ALERT_SX = {
  mb: 2,
  '& .MuiAlert-icon': {
    marginLeft: 1
  }
}

export const SPECIAL_PRICE_CREATE_SECTION_ALERT_SX = {
  mb: 3
}

export const SPECIAL_PRICE_CREATE_RANGE_ALERT_SX = {
  mt: 1.5
}

export const SPECIAL_PRICE_CREATE_SCOPE_SELECT_SX = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#ffffff'
  }
}

export const SPECIAL_PRICE_CREATE_AUTOCOMPLETE_SX = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#ffffff'
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: '#f3f4f6'
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: '#6b7280'
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#6b7280'
  },
  '& .MuiAutocomplete-popupIndicator.Mui-disabled': {
    color: '#9ca3af'
  },
  '& .MuiAutocomplete-clearIndicator.Mui-disabled': {
    color: '#9ca3af'
  }
}
